import { requireSupabase } from "@/lib/supabaseClient";
import { guard } from "@/lib/errors";

export const favoriteService = {
  list: (userId) =>
    guard("favoriteService.list", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase
        .from("favorites")
        .select("property_id, created_at, property:properties(*, images:property_images(*))")
        .eq("user_id", userId)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data || [];
    }),

  add: (userId, propertyId) =>
    guard("favoriteService.add", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase.from("favorites").insert({ user_id: userId, property_id: propertyId });
      if (error) throw error;
      return true;
    }),

  remove: (userId, propertyId) =>
    guard("favoriteService.remove", async () => {
      const supabase = requireSupabase();
      const { error } = await supabase
        .from("favorites")
        .delete()
        .eq("user_id", userId)
        .eq("property_id", propertyId);
      if (error) throw error;
      return true;
    }),

  isFavorite: (userId, propertyId) =>
    guard("favoriteService.isFavorite", async () => {
      const supabase = requireSupabase();
      const { data, error } = await supabase
        .from("favorites")
        .select("property_id")
        .eq("user_id", userId)
        .eq("property_id", propertyId)
        .maybeSingle();
      if (error) throw error;
      return Boolean(data);
    }),
};
